module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q5-lockup.4bfba77d.png";